import { Component, Inject, OnInit } from '@angular/core';
import { MODAL_DATA, NgbActiveModal } from '@agilent/ui-element';
import { FormControl, FormGroup } from '@angular/forms';

interface IUserReasonModalData {
    title: string;
}

@Component({
    selector: 'ac-user-reason-dialog',
    templateUrl: './ac-user-reason-dialog.component.html'
})
export class AcUserReasonDialogComponent {

    dialogTitle = 'Reason Required';
    appUserReasonForm: FormGroup;

    constructor(
        @Inject(MODAL_DATA) private modalData: IUserReasonModalData,
        private activeModal: NgbActiveModal
    ) {
        //
        this.dialogTitle = modalData.title || 'Reason';
    }

    formIsReady(reasonForm: FormGroup) {
        this.appUserReasonForm = reasonForm;
    }

    async save() {
        this.activeModal.close({reason: this.appUserReasonForm.controls['userReason'].value});
    }

    cancel() {
        this.activeModal.dismiss();
    }

    isYesButtonDisabled() {
        return (
            !this.appUserReasonForm.dirty ||
            this.appUserReasonForm.invalid
        );
    }

}
